<template>
  <el-dialog :visible.sync="isLogin" width="33.125rem" :before-close="clearlogin" :modal-append-to-body="true"
    :modal="false">
    <div class="login">

      <div class="register_container" v-if="isRegister">
        <div class="" style="margin-bottom: 1.25rem;">
          打开微信扫一扫快速注册
        </div>
        <el-image src="https://file.aavisa.com/browser-upload-file/b97a6f3c-5c7b-4e61-84fe-8678ab168cbf.jpg" fil="fill"
          style="width: 100%;"></el-image>
      </div>

      <div :id="Id">

      </div>



      <div class="login_bottom">
        <div>
          登录即同意<span style="color: #599fff;cursor:pointer;" @click="goLink('/privacy')">《隐私政策》</span>
        </div>
        <div class="login_bottom_register" v-if="!isRegister" @click="changeRegister">
          免费注册
        </div>
        <div class="login_bottom_register" v-else @click="changeRegister">
          返回登录
        </div>
      </div>
    </div>
  </el-dialog>



</template>

<script>
  export default {
    components: {

    },
    name: 'login',
    props: {
      Register: {
        type: Boolean,
        default: false
      },
      Id: {
        type: String,
        default: 'login_container'
      }
    },
    data() {
      return {
        isLogin: false,
        isRegister: false
      }
    },
    watch: {
      Register(newval) {

        if (this.isLogin != true) {
          console.log(newval)
          this.isLogin = false
          this.isLogin = true
        }
        this.checkLogin()
        this.isRegister = newval
      }
    },
    created() {

    },
    methods: {
      changeRegister() {
        this.isRegister = !this.isRegister
      },

      goLink(url) {
        window.open(url)
      },

      checkLogin() {
        console.log('checkLogin')
        // debugger
        if (cookie.get('auth') && cookie.get('MemberId') && cookie.get("PcMemberId")) {
          this.move()
          this.isLogin = false
          return true
        } else {
          this.stop()
          this.loadSDK()
          this.isLogin = true
          return false
        }
      },

      clearlogin() {
        this.isLogin = false
        this.move()
      },

      loadSDK() {

        //vue创建一个script元素 内容为一个函数，该函数执行，并且将它插入到body的最后
        const script = document.createElement('script');

        script.src = 'https://aavisa.com/content/wxLogin.js';
        script.onload = this.wxLogin;
        document.body.appendChild(script)
      },


      wxLogin() {
        var obj = new WxLogin({
          self_redirect: false,
          id: this.Id,
          appid: "wx4e63c0f52aa0f324",
          scope: "snsapi_login",
          redirect_uri: "https%3a%2f%2faavisa.com/",
          // redirect_uri: "https%3A%2F%2Fwww.testaavisa.com%2F",
          state: "",
          style: "",
          href: "",
        });
      },

      // CheckCodeLogin(code) {
      //   this.$api.CheckCodeLogin({
      //     Code: code
      //   }).then(res => {
      //     console.log(res)
      //     if (res.data.result) {
      //       cookie.set('auth', res.data.data.token)
      //       cookie.set('MemberId', res.data.data.Id)
      //       cookie.set('storeId', res.data.data.StoreId)
      //       cookie.set('Contacts', res.data.data.Contacts)
      //     } else {
      //       this.$message.error(res.data.message)
      //     }
      //   })
      // },

      //禁止滚动
      stop() {
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = 'hidden';
        document.addEventListener("touchmove", mo, false); //禁止页面滑动
      },

      /***取消滑动限制***/
      move() {
        var mo = function (e) {
          e.preventDefault();
        };
        document.body.style.overflow = ''; //出现滚动条
        document.removeEventListener("touchmove", mo, false);
      }
    },
  }

</script>

<style lang="less" scoped>
  /deep/ .el-dialog {
    border-radius: 8px;
  }

  /deep/ .el-dialog__body {
    padding: 0 !important;
  }

  .page {
    z-index: 99999;
  }

  .login {
    // height: 39.25rem;
    height: 37.5rem;
    width: 100%;
    z-index: 100;
    border-radius: 8px;
    background-color: #fff;

    #login_container {
      width:23.4375rem;
      height: 24.75rem;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .register_container {
      width: 22.4375rem;
      height: 25.75rem;
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      z-index: 999;
    }

    .login_bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 3.625rem;
      background: #f6faff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 1.875rem;
      padding-right: 1.875rem;

      &>div {
        font-size: 0.875rem;
      }

      .login_bottom_register {
        color: #599fff;
        font-size: 1rem;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/login/login.vue